import { PixelIcon } from './PixelIcon'
import type { PixelIconName } from '@/game/pixelIcons'

interface ChipProps {
  icon: PixelIconName
  value: number | string
  color?: string
  label?: string
}

function formatCount(value: number | string): string {
  if (typeof value !== 'number') return value
  if (value >= 100000) return `${Math.floor(value / 1000)}k`
  if (value >= 10000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`
  return String(value)
}

function Chip({ icon, value, color = 'var(--text)', label }: ChipProps) {
  return (
    <div
      className="inline-flex items-center gap-1 rounded-full bg-[var(--surface-sunken)] px-2.5 py-1.5 shadow-sunken"
      aria-label={label ? `${label}: ${value}` : undefined}
    >
      <PixelIcon name={icon} size={15} className="shrink-0" />
      <span className="font-display text-sm font-bold tabular-nums leading-none" style={{ color }}>
        {formatCount(value)}
      </span>
    </div>
  )
}

interface CurrencyDisplayProps {
  coins: number
  gems: number
  lives?: number
  className?: string
}

export function CurrencyDisplay({ coins, gems, lives, className = '' }: CurrencyDisplayProps) {
  return (
    <div className={['flex shrink-0 items-center gap-1.5', className].join(' ')}>
      <Chip icon="coin" value={coins} color="var(--coin)" label="Coins" />
      <Chip icon="gem" value={gems} color="var(--gem)" label="Gems" />
      {lives != null && <Chip icon="heart" value={lives} color="var(--danger)" label="Lives" />}
    </div>
  )
}

export { Chip as CurrencyChip }
